import { AfterViewInit, Component } from '@angular/core';

@Component({
    selector: '[app-drivers-dashboard]',
    templateUrl: './drivers-dashboard.component.html',
    styleUrls: ['./drivers-dashboard.component.css'],
    standalone: false
})

export class DriversDashboardComponent implements AfterViewInit
{
  ngAfterViewInit() {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "DriversDashboard" }));
  }
}
